






import { Component, Prop, Vue } from 'vue-property-decorator'
import { Module } from '@/api/types'

@Component
export default class ModuleEnabled extends Vue {
    @Prop({ required: true }) readonly module!: Module
    @Prop({ default: 'div' }) readonly tag!: string

    get isActive(): boolean {
        return this.$currentCompany.modules.includes(this.module)
    }
}
